import Vue from 'vue'
import axios from 'axios'

const host = process.env.VUE_APP_API_SERVER
const path = '/api/check'

export default {
  check() {
    let jwt = Vue.prototype.$session.get('jwt')
    let headers = {
      'Authorization': 'Bearer ' + jwt
    }
    return axios.get(host + path, { headers })
      .then(response => {
        let res = response.data
        if (res.correcto) {
          return true
        } else {
          Vue.prototype.$session.destroy()
          return false
        }
      })
      .catch(error => {
        Vue.prototype.$session.destroy()
        return false
      })
  }
}
